var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg081UpArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.454,311.567c-7.811-7.812-20.476-7.812-28.288,0c-7.811,7.811-7.811,20.475,0,28.287c7.8,7.799,7.8,20.488,0,28.287 c-3.778,3.777-8.801,5.859-14.144,5.859H59.979c-5.343,0-10.366-2.081-14.144-5.859c-7.8-7.799-7.8-20.488,0-28.287 l196.021-196.021c7.797-7.799,20.486-7.799,28.256-0.031l128.73,129.296c7.794,7.83,20.458,7.857,28.287,0.063 c7.829-7.794,7.857-20.458,0.062-28.287l-128.76-129.329c-23.398-23.398-61.466-23.398-84.863,0L17.547,311.566 c-23.397,23.398-23.397,61.466,0,84.862c11.334,11.334,26.404,17.576,42.432,17.576h392.043c16.028,0,31.097-6.242,42.432-17.575 C517.85,373.032,517.85,334.964,494.454,311.567z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg081UpArrow2);
export default __webpack_public_path__ + "static/media/081-up-arrow-2.2eb1c34bf1d58bd83a660ef3d26aaf23.svg";
export { ForwardRef as ReactComponent };